module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/events/events.component.scss
// module id = ./src/app/routes/events/events.component.scss
// module chunks = 9